import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Stack,
  Link,
  Typography,
  TypographyListItem,
} from '@gogame/components';
import { AmountFormatter } from '@gogame/intl-ts';

import MonthlyBudget from '../MonthlyBudget';

const General = ({
  data,
  onOpenDetails,
  onOpenBusinessPartner,
  onOpenAffiliate,
}) => {
  return (
    <DescriptionList stripEmpty={true} data={data} disableGutters={true}>
      <DescriptionItem
        label={'IO ID'}
        field={'parentIo'}
        type={'link'}
        onValueClick={(e, parentIo) => onOpenDetails(e, { id: parentIo })}
      />
      <DescriptionItem
        label={'Period'}
        field={'period'}
        type={'dateRange'}
        template={'MONTH'}
        timeZone={'utc'}
      />
      <DescriptionItem
        label={'Business partner'}
        field={'businessPartner'}
        type={({ value: { name, version, id } }) => (
          <Stack direction={'row'} spacing={0.5}>
            <Typography>
              <Link onClick={(e) => onOpenBusinessPartner(e, { id })}>
                {name}
              </Link>
            </Typography>
            {!!version && <Typography>({version.name})</Typography>}
          </Stack>
        )}
      />
      <DescriptionItem
        label={'Customer Company'}
        field={'customerCompany.name'}
      />
      <DescriptionItem
        label={'Affiliates'}
        field={'affiliates'}
        type={'typographyList'}
        unitsLabel={'Affiliates'}
        limit={1}
        item={({ id, name }) => {
          return (
            <Link
              /* eslint-disable-next-line */
              data-cy-type={'link'}
              onClick={(e) => onOpenAffiliate(e, { id })}
            >
              <TypographyListItem>{name}</TypographyListItem>
            </Link>
          );
        }}
      />
      <DescriptionItem
        label={'Owner'}
        field={'owner'}
        type={({ value: { name, email } }) => (
          <Stack direction={'row'} spacing={0.5}>
            {!!name && <Typography>{name}</Typography>}
            {email && (
              <Typography>
                <Link href={`mailto:${email}`} target={'_blank'}>
                  {email}
                </Link>
              </Typography>
            )}
          </Stack>
        )}
      />
      <DescriptionItem label={'Agreement type'} field={'agreementType.name'} />
      <DescriptionItem
        label={'GoGame Access Paragraph'}
        field={'accessParagraphType.name'}
      />

      <DescriptionItem
        label={'Total budget'}
        field={'totalBudget'}
        type={'amount'}
      />

      <DescriptionItem
        label={'Rate of Net Rev.'}
        field={'revShareBudget.rateOfNet'}
        type={'percent'}
      />
      <DescriptionItem label={'Currency'} field={'totalBudget.currencyCode'} />
      <DescriptionItem
        label={'Monthly budget'}
        field={'monthlyBudget'}
        type={({ value: monthlyBudgets }) => {
          return data.isEqualMonthsBudgets ? (
            <Typography>
              <AmountFormatter {...monthlyBudgets?.[0]?.amount} />
            </Typography>
          ) : (
            <MonthlyBudget monthly={monthlyBudgets} circle={true} />
          );
        }}
      />
      <DescriptionItem label={'Payment term'} field={'paymentTerms.name'} />
      <DescriptionItem label={'Expense type'} field={'expenseType.name'} />
      <DescriptionItem
        label={'Traffic restrictions'}
        field={'trafficRestrictions'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        label={'Invoice requirements'}
        field={'invoiceRequirements'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        label={'Additional invoice requirements'}
        field={'additionalInvoiceRequirements'}
      />
      <DescriptionItem
        label={'Conversions Approval comment'}
        field={'conversionsApprovalComment'}
      />
      <DescriptionItem
        label={'GDPR start date'}
        field={'gdprStartDate'}
        template={'LLL'}
        timeZone={'utc'}
      />

      <DescriptionItem label={'Description'} field={'description'} />
    </DescriptionList>
  );
};

export default General;
